var exports = {
  "k": "xe564cbfb--4c7e2c--container",
};

module.exports = exports;
